// actions to get slides from the database
import axios from "axios";
import { API_URL } from "../variables";

export const FETCH_BRANDS_REQUEST = "FETCH_BRANDS_REQUEST";
export const FETCH_BRANDS_SUCCESS = "FETCH_BRANDS_SUCCESS";
export const FETCH_BRANDS_FAILURE = "FETCH_BRANDS_FAILURE";

export const fetchBrands = () => async (dispatch) => {
  dispatch({ type: FETCH_BRANDS_REQUEST });
  try {
    const response = await axios.post(`${API_URL}/api/products/brands?page=1`, {
      pagination: 1000,
    });
    dispatch({ type: FETCH_BRANDS_SUCCESS, payload: response.data.results });
  } catch (error) {
    dispatch({ type: FETCH_BRANDS_FAILURE, payload: error.message });
  }
};
